import { useNavigate } from "react-router-dom";
import { UserContext } from "../lib/UserContext";
import Loading from "../components/Loading";
import { useContext, useEffect, useState } from "react";
import Modal from 'react-modal';

const Values = () => {
  const navigate = useNavigate();
  const [user, setUser] = useContext(UserContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalTitle = "The Value of Purpose";
  const modalDescription = "Purpose provides direction and focus for the development of decentralized systems and applications.";

  
  useEffect(() => {
     user && !user.userId && !user.userName && navigate("/login");
  }, [user, navigate]);
  
  const startQuestions = () => {
    navigate("/questions");
  }

  const logoutUser = () => {
    setUser({"userId":null, "userName":null, "magicLinkAccount":null})
  }

  return (
    <>
     <Modal isOpen={isModalOpen} className='h-80 w-80 my-40 border rounded-3xl p-3 bg-white text-center border-gray-100 shadow-lg mx-auto d-flex flex-column justify-content-space-between py-2'>
        <h2 className="font-bold text-center text-black pt-4 py-2">{modalTitle}</h2>
        <p className="text-black">{modalDescription}</p>
        <div className="d-flex justify-center py-2">
          <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={() => setIsModalOpen(false)}>Close</button>
        </div>
      </Modal>

      <div className="bg-header h-screen font-inter">
        <div className="px-6 pt-6 lg:px-8">
          <nav className="flex items-center justify-between">
            <div className="flex lg:flex-1">
              <a href="" className="-m-1.5 p-1.5">
                <span className="sr-only">Celium</span>
                <img
                  className="h-14"
                  src={"image/celium-white.png"}
                  alt="celium-logo"
                />
              </a>
            </div>
              <div>
                <button onClick={() => navigate('/profile')} className="mr-5">Profile</button>
<button onClick={logoutUser}>Logout</button>
              </div>
          </nav>
        </div>
        <div className="container mx-auto">
          <div className="sm:flex flex-row ">
            <div className="text-center p-5 sm:p-8 md:p-20">
              <h1 className="text-3xl sm:text-5xl md:text-6xl xl:text-7xl font-bold tracking-tight text-white font-inter">
                We are connecting people and organizations through the values of decentralization.
              </h1>
              <p className="text-2xl sm:text-3xl md:text-4xl sm:p-8 pt-20">
                Each test can be completed in less than five minutes and must be completed in one sitting. Please select the test you ent to take and you will receive your free Glyph immediately.
              </p>
              <button onClick={startQuestions} className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500  hover:to-indigo-500 hover:via-purple-500 hover:from-pink-500 hover:shadow-lg text-black font-bold py-3 px-8 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12">
                The First value
            </button>
            <button className="text-white px-6 py-2 text-xl" onClick={() => setIsModalOpen(true)}>Need help?</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Values;
